import { render, staticRenderFns } from "./DigitalPaperList.vue?vue&type=template&id=b46e1b32&"
import script from "./DigitalPaperList.vue?vue&type=script&lang=ts&"
export * from "./DigitalPaperList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports